import { Box, Flex, Text, Image } from '@chakra-ui/react';
import bg2 from '../../../assets/image/home/bg2.png';
import Sentiment from '../../../assets/image/home/Sentiment.png';
import Strategy from '../../../assets/image/home/Strategy.png';
import Trading from '../../../assets/image/home/Trading.png';
import AutoTrade from '../../../assets/image/home/AutoTrade.png';
import UserCreated from '../../../assets/image/home/User-Created.png';

import { useState } from 'react';
import { importAll } from '../../../utils/utils';
import { useIsMobile } from '../../../hooks/useIsMobile';
import styles from './NewHomeAssistant.module.scss';
import classNames from 'classnames';

const icons = importAll(require.context('../../../assets/image/home/solution', false, /\.(svg)$/));

const items = [
  {
    label: 'TRADING ASSISTANCE',
    value: 0,
    desc: 'Trading Assistance offers personalized suggestions and predictions, based on users&apos; trading behaviors and relevant news, to deliver tailored trading signals and empower traders to make informed decisions more efficiently and intelligently.'
  },
  {
    label: 'SENTIMENT ANALYSIS',
    value: 1,
    desc: 'Sentiment Analysis gauges the overall market sentiment for a particular token, to allow users to make data-driven price predictions. Positive sentiment may indicate a potential price increase, while negative sentiment may suggest a potential price drop.'
  },
  {
    label: 'TRENDING SCORE',
    value: 2,
    desc: 'Strategy Square provides access to AI-optimized trading strategies, along with a community forum for exchanging insight and trading tips. Users are also granted the ability to develop their own AI-powered trading strategies.'
  },
  {
    label: 'AI Strategy Autotrade',
    value: 3,
    desc: 'Execute automated AI-driven trading strategies that analyze real-time data and execute trades 24/7'
  },
  {
    label: 'User-Created Strategies',
    value: 4,
    desc: 'Users can easily build, test, and deploy their own trading strategies on-chain with no coding required.'
  }
];

const solutions = [
  {
    title: 'Private and Secure',
    content:
      'ALLOYX ensures your transactions and data are fully protected with advanced encryption and AI-driven threat detection. Your privacy is our priority, allowing you to trade with confidence and peace of mind.'
  },
  {
    title: 'Seamless Trading',
    content:
      'Experience smooth trading with ALLOYX fast, reliable and user-friendly interface that integrates seamlessly, making trading intuitive and efficient.'
  },
  {
    title: 'Personalized',
    content:
      'ALLOYX delivers tailored, AI-driven trading insights. Our platform analyzes your patterns to provide personalized recommendations, enhancing your trading experience and helping you make informed decisions.'
  },
  {
    title: 'Efficient',
    content:
      'ALLOYX streamlines operations, ensuring rapid trade execution and reduced latency. Act quickly on market opportunities with our efficient system, maximizing your trading potential with minimal effort.'
  },
  {
    title: 'Sentiment analysis',
    content:
      'Stay informed with ALLOYX advanced sentiment analysis. The tool monitors market sentiment shifts, providing proactive alerts and comprehensive market insights for better trading decisions to help you stay ahead of trends.'
  },
  {
    title: 'Transaction Diversity',
    content:
      'ALLOYX supports diverse assets and transactions. Our AI-driven analytics guide you in exploring new markets, optimizing your trading strategies, and discovering new opportunities with ease.'
  }
];

const screens = [Sentiment, Strategy, Trading, AutoTrade, UserCreated];

export default function () {
  const [current, setCurrent] = useState(0);

  const isMobile = useIsMobile();

  return (
    <Flex
      width="100%"
      flexDir="column"
      color="white"
      justifyContent={'center'}
      alignItems={'center'}
      pt={{ base: '40px', md: '85px' }}>
      <Text
        textAlign={'center'}
        fontSize={isMobile ? '20px' : '66px'}
        fontWeight={400}
        fontFamily="Georgia"
        maxW={825}
        lineHeight="100%"
        data-aos="fade-right"
        data-aos-once={true}
        data-aos-duration="1500">
        Your On-Chain Copilot for Intelligent Trading
      </Text>
      <Text
        fontSize="16px"
        lineHeight="100%"
        data-aos="fade-left"
        maxW="486px"
        data-aos-once={true}
        data-aos-duration="1500"
        mt="11px"
        textAlign={'center'}>
        AlloyX is an AI-driven decentralized trading layer that unifies liquidity across multiple blockchains. Powered
        by advanced trading intelligence, it enables users to execute smarter, faster, and more secure cross-chain
        trading.
      </Text>

      <Box marginTop={{ base: '50px', md: '104px' }}>
        <Flex
          gap={['10px']}
          alignItems={'center'}
          justifyContent="center"
          flexDir={{ base: 'column', md: 'row' }}
          flexWrap={'wrap'}>
          {items.map((item, i) => {
            return (
              <Box
                onClick={() => {
                  setCurrent(i);
                }}
                borderRadius={'47px'}
                padding={{ base: '10px 30px', lg: '25px 45px' }}
                textAlign={'center'}
                key={item.label}
                fontSize={{ base: 16, lg: 24 }}
                cursor={'pointer'}
                bg={current === item.value ? '#394DEE' : ''}
                fontFamily="Manrope"
                fontWeight={600}
                color="#fff">
                {item.label}
              </Box>
            );
          })}
        </Flex>

        {/* <Box
          color="#fff"
          maxWidth={'513px'}
          mx="auto"
          fontFamily="Manrope"
          textAlign={'center'}
          fontSize={'16px'}
          marginTop={'46px'}>
          <div dangerouslySetInnerHTML={{ __html: items[current].desc }}></div>
        </Box> */}
      </Box>

      <Box marginTop={'73px'} pos={'relative'} w="full">
        <Image src={screens[current]} pos={'absolute'} top={'1%'} left={'4%'} w={'92%'}></Image>
        <Image src={bg2} objectFit="cover" w="full"></Image>
      </Box>

      <Box
        marginTop={{ base: '100px', md: '183px' }}
        fontSize={isMobile ? '12px' : '16px'}
        bg={'#394DEE'}
        color="white"
        h="30px"
        py="4px"
        fontWeight={400}
        rounded="full"
        w="147px"
        textAlign="center"
        fontFamily="Manrope">
        WHY ALLOYX?
      </Box>

      <Text
        textAlign={'center'}
        mt={'33px'}
        fontSize={isMobile ? '20px' : '48px'}
        lineHeight="1.2"
        fontFamily="Georgia"
        data-aos="fade-right"
        data-aos-once={true}
        data-aos-duration="1500">
        AI Smart Trade Layer <br /> — Revolutionizing the Way You Interact with Markets
      </Text>
      <div className={styles.solution}>
        {solutions.map((item, i) => {
          return (
            <div key={item.title} className={classNames(styles['solution-wrapper'])}>
              <div className={styles['solution-item']}>
                <Image src={icons[i]} margin={isMobile ? '0 auto' : ''} width={'32px'} height={'32px'} />
                <Box
                  fontSize={'24px'}
                  fontFamily="Georgia"
                  fontWeight={600}
                  textAlign={isMobile ? 'center' : 'left'}
                  mt="28px"
                  mb="30px">
                  {item.title}
                </Box>
                <Box fontFamily="Manrope" fontSize="16px" maxW="314px" textAlign={isMobile ? 'center' : 'left'}>
                  <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                </Box>
              </div>
            </div>
          );
        })}
      </div>
    </Flex>
  );
}
